
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/editorial/resources",
      function () {
        return require("private-next-pages/editorial/resources.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/editorial/resources"])
      });
    }
  